import * as React from 'react';
import { observer } from 'mobx-react';
import { ConversationSummary } from 'nomst/Stores/Decision/conversationSummary';
import { ICountryDecisionDispatcher } from 'typings/countryDecision.dispatcher';
import './conversationBadge.scss';

export interface IConversationBadgeProps {
    countryDecisionDispatcher: ICountryDecisionDispatcher;
    conversationSummary: ConversationSummary;
}

export class ConversationBadge extends React.Component<IConversationBadgeProps> {
    constructor(props: IConversationBadgeProps) {
        super(props);
        this.handleOpen = this.handleOpen.bind(this);
    }

    render(): React.ReactNode {
        const { conversationSummary } = this.props;
        if (!conversationSummary) {
            return null;
        }

        return (
            <span className="nomst-conversation-badge">
                {this.renderBadge()}
            </span>
        );
    }

    private renderBadge(): React.ReactNode {
        return (
            <button
                className={this.summaryBadgeClasses}
                onClick={this.handleOpen}
            >
                <i className="icon-chat" />
                {this.renderSummaryDetails()}
            </button>
        );
    }

    private get summaryBadgeClasses(): string {
        const { conversationSummary } = this.props;
        if (conversationSummary.hasMessages) {
            return 'no-btn-style badge-with-message';
        }

        return 'no-btn-style badge-without-message';
    }

    private renderSummaryDetails(): React.ReactNode {
        const { conversationSummary } = this.props;
        return (
            <span>
                <i
                    className="notification-dot icon-circle"
                    hidden={conversationSummary.hasNoUnreadMessages}
                />
            </span>
        );
    }

    private handleOpen(): void {
        const { countryDecisionDispatcher, conversationSummary } = this.props;
        countryDecisionDispatcher.dispatchSelectConversation(conversationSummary.entityId);
    }
}

export default observer(ConversationBadge);